import React, { useRef } from 'react'
import CircleActiveFilterBtn from '../../../../../../generic/particles/CircleActiveFilterBtn'
import styled from 'styled-components'
import AcceptIcon from '../../../../../../generic/icons/IconLib/CheckIcon'
import BarCodeIcon from '../../../../../../generic/icons/IconLib/BarcodeIcon'
import DeleteIcon from '../../../../../../generic/icons/IconLib/TrashIcon'
import ScanInput, { IRef } from '../../../kosherTeudot/Components/ScanInput'
import { IResponseSrikaNode, ISrikaItem } from '../../../../../../modules/API/Gathering/models/srika'
import PalletProductCard from './PalletProductCard'

type Props = {
  locationData: IResponseSrikaNode | null
  handleScanLocation: (location: string) => void
  clearScannedDataLocation: () => void
  input: string
  setInput: (s: string) => void
}

const LocationCard = ({
  locationData,
  handleScanLocation,
  clearScannedDataLocation,
  input,
  setInput,
}: Props) => {
  const refInput = useRef<IRef>(null)

  const handleClearScannedDataLocation = () => {
    clearScannedDataLocation()
  }

  const handleScan = () => {
    handleScanLocation(input)
  }


  return (
    <MainWrapper>
      <Title>
      ברקוד איתור
       </Title>
      <BlockWrapper>
        {
            locationData ? (
            <CircleActiveFilterBtn
              func={handleClearScannedDataLocation}
            >
              <DeleteIcon />
            </CircleActiveFilterBtn>
          ) :  input && input.length > 0 && (
            <CircleActiveFilterBtn
              func={handleScan}
            >
                <AcceptIcon />
            </CircleActiveFilterBtn>
          )
        }
        <ScanInput
          ref={refInput}
          setInput={setInput}
          input={input}
          enterFunc={handleScan}
          icon={<BarCodeIcon />}
        />
        </BlockWrapper>
        {
          locationData && (
            <>
            {
              locationData.entryLine.length > 0 ?
              locationData.entryLine.map((item: ISrikaItem) => (
                <BlockWrapper>
                  <PalletProductCard palletData={item} />
                </BlockWrapper>
              ))
              :
              <BlockWrapper>
                <EmptyMessage>אין פריטים במיקום זה</EmptyMessage>
              </BlockWrapper>
            }
            </>
          )
        }
    </MainWrapper>
  )
}

const MainWrapper = styled.div`
  padding: 0.2em;
  border-radius: 30px;
  background: #f2f2f2;
  display: flex;
  flex-flow: column;
  gap: 0.2em;
`
const Title = styled.h3`
  font-size: 1em;
  font-weight: 600;
  text-align: center;
  color: #297F76;
`
const BlockWrapper = styled.div`
  width: 100%;
  padding: 0.1em;
  display: flex;
  gap: 0.2em;
  border-radius: 30px;
  background: #fff;
`

const EmptyMessage = styled.div`
  padding: 2em;
  text-align: center;
  color: #7f8c8d;
  font-size: 1em;
`

export default LocationCard